import axiosClient from "./axiosClient";


export const  CodeLineageConfigAPI=  {
    
  postconnectRepo(payload)  {
   
    return axiosClient.post(`/api/repo/connect`,payload);
},

 postdownLoadFiles(payload)  {
   
    return axiosClient.post(`/api/repo/download`,payload);
},
languageChecking(payload){
     return axiosClient.post(`/api/files/analyze`,payload);
},
JSONGenerate(payload){
    return axiosClient.post(`/api/lineage/json-generate`,payload);
},
graphDB(payload){
    return axiosClient.post(`/api/lineage/graphdb-ingestion`,payload);
},
 repocleanup(payload){
     return axiosClient.post(`/api/repo/cleanup`,payload);
 },

 postApi_BatchProcessing(payload){
      return axiosClient.post(`/api/files/batch-processing`,payload);
 },

 postApi_BatchProcessing_status(payload){
     return axiosClient.post(`/api/lineage/batch/status`,payload);
 }
};
